(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chat-widget"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var widget = document.querySelector('[data-chat-widget]');
    if (!widget) return;

    var toggle = widget.querySelector('.chat-widget__toggle');
    var dialog = widget.querySelector('.chat-widget__dialog');
    var close = widget.querySelector('.chat-widget__close');
    var iframe = widget.querySelector('.chat-widget__iframe');
    var loading = widget.querySelector('.chat-widget__loading');
    if (!toggle || !dialog || !close || !iframe) return;

    var src = widget.getAttribute('data-iframe-src');
    var openDelay = parseInt(widget.getAttribute('data-open-delay') || '0', 10);
    var openOnProduct = widget.getAttribute('data-open-on-product') === 'true';
    var autoOpen = widget.getAttribute('data-auto-open') === 'true';
    var isProductPage = widget.getAttribute('data-is-product-page') === 'true';
    var welcomeMessage = widget.getAttribute('data-welcome-message') || 'Bem vindo';
    var assistantName = widget.getAttribute('data-assistant-name') || 'Aurora';
    var primaryColor = widget.getAttribute('data-primary-color') || '#007bff';
    var secondaryColor = widget.getAttribute('data-secondary-color') || '#363636';
    var backgroundColor = widget.getAttribute('data-background-color') || '#2c2c2c';
    var ctaEnabled = widget.getAttribute('data-cta-enabled') === 'true';
    var ctaMessage = widget.getAttribute('data-cta-message') || 'Precisa de Ajuda?';
    var ctaDelay = parseInt(widget.getAttribute('data-cta-delay') || '5', 10);
    var ctaDuration = parseInt(widget.getAttribute('data-cta-duration') || '10', 10);

    var widgetReady = false;
    var contentReady = false;
    var iframeLoaded = false;
    var shopifyDataSent = false;
    var ctaTriggered = false;
    var ctaTimerId = null;
    var originalLabelText = toggle.querySelector('.chat-widget__toggle-label').textContent;

    function buildChatUrl(baseUrl) {
      if (!baseUrl) return baseUrl;
      try {
        var url = new URL(baseUrl);
        url.searchParams.set('primaryColor', primaryColor);
        url.searchParams.set('secondaryColor', secondaryColor);
        url.searchParams.set('backgroundColor', backgroundColor);
        return url.toString();
      } catch (e) {
        var separator = baseUrl.includes('?') ? '&' : '?';
        return baseUrl + separator +
          'primaryColor=' + encodeURIComponent(primaryColor) +
          '&secondaryColor=' + encodeURIComponent(secondaryColor) +
          '&backgroundColor=' + encodeURIComponent(backgroundColor);
      }
    }

    function buildShopifyData() {
      return {
        type: 'SHOPIFY_DATA',
        customer: window.shopifyCustomerData || null,
        product: window.shopifyProductData || null,
        proactiveGreeting: isProductPage && !!window.shopifyProductData,
        welcomeMessage: welcomeMessage,
        colors: {
          primary: primaryColor,
          secondary: secondaryColor,
          background: backgroundColor
        },
        timestamp: Date.now()
      };
    }

    function sendShopifyDataToIframe() {
      if (shopifyDataSent) return;
      try {
        iframe.contentWindow.postMessage(buildShopifyData(), '*');
      } catch (e) {
        console.error('[ChatWidget] Failed to send Shopify data:', e);
      }
    }

    function sendShopifyDataWithRetries() {
      var retries = 0;
      var maxRetries = 10;
      var interval = setInterval(function () {
        if (shopifyDataSent || retries >= maxRetries) {
          clearInterval(interval);
          return;
        }
        sendShopifyDataToIframe();
        retries++;
      }, 300);
      sendShopifyDataToIframe();
    }

    function showIframe() {
      if (iframe.hasAttribute('data-loaded')) return;
      if (loading) {
        loading.setAttribute('aria-hidden', 'true');
      }
      iframe.setAttribute('data-loaded', 'true');
      iframe.style.opacity = '1';
    }

    window.addEventListener('message', function (event) {
      if (!event.data || typeof event.data.type !== 'string') return;

      if (event.data.type === 'WIDGET_READY') {
        widgetReady = true;
        shopifyDataSent = true;
        // Não mostra iframe aqui - aguarda CHAT_CONTENT_READY
      }

      if (event.data.type === 'CHAT_CONTENT_READY') {
        contentReady = true;
        showIframe();
      }

      if (event.data.type === 'SHOPIFY_DATA_RECEIVED') {
        shopifyDataSent = true;
      }
    });

    function openChat() {
      if (dialog.open) return;

      dialog.show();
      toggle.setAttribute('aria-expanded', 'true');

      if (src && iframe.src === 'about:blank') {
        if (loading) {
          loading.setAttribute('aria-hidden', 'false');
        }
        iframe.style.opacity = '0';
        iframe.removeAttribute('data-loaded');

        var chatUrl = buildChatUrl(src);
        iframe.src = chatUrl;

        iframe.addEventListener('load', function onIframeLoad() {
          iframe.removeEventListener('load', onIframeLoad);
          iframeLoaded = true;
          sendShopifyDataWithRetries();
        }, { once: true });

        // Timeout removido - aguarda CHAT_CONTENT_READY do iframe
      } else if (iframe.src && iframe.src !== 'about:blank') {
        if (loading) {
          loading.setAttribute('aria-hidden', 'true');
        }
        iframe.setAttribute('data-loaded', 'true');
        iframe.style.opacity = '1';

        sendShopifyDataToIframe();
      } else {
        if (loading) {
          loading.setAttribute('aria-hidden', 'true');
        }
      }
    }

    function closeChat() {
      if (!dialog.open) return;
      dialog.close();
      toggle.setAttribute('aria-expanded', 'false');
      dialog.removeAttribute('data-open');
    }

    toggle.addEventListener('click', openChat);
    close.addEventListener('click', closeChat);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeChat();
      }
    });

    if (autoOpen && openDelay > 0) {
      var shouldAutoOpen = true;

      if (openOnProduct && !isProductPage) {
        shouldAutoOpen = false;
      }

      if (shouldAutoOpen) {
        setTimeout(function () {
          if (!dialog.open) {
            openChat();
          }
        }, openDelay * 1000);
      }
    }

    if (ctaEnabled && ctaDelay >= 0) {
      var label = toggle.querySelector('.chat-widget__toggle-label');

      function activateCta() {
        if (ctaTriggered || dialog.open) return;
        ctaTriggered = true;
        label.textContent = ctaMessage;
        toggle.classList.add('chat-widget__toggle--cta-active');
        setTimeout(function () {
          deactivateCta();
        }, ctaDuration * 1000);
      }

      function deactivateCta() {
        toggle.classList.remove('chat-widget__toggle--cta-active');
        label.textContent = originalLabelText;
      }

      ctaTimerId = setTimeout(function () {
        if (!dialog.open) {
          activateCta();
        }
      }, ctaDelay * 1000);

      toggle.addEventListener('click', function () {
        if (ctaTriggered) {
          deactivateCta();
        }
        if (ctaTimerId) {
          clearTimeout(ctaTimerId);
          ctaTimerId = null;
        }
      });

      if (window.matchMedia('(hover: hover)').matches) {
        toggle.addEventListener('mouseleave', function () {
          if (toggle.classList.contains('chat-widget__toggle--cta-active')) {
            deactivateCta();
          }
        });
      }
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jv-richtext"] && !Shopify.designMode) return;
  try {
    
  /* Adicione scripts personalizados aqui se necessário */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-sticky-cta"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobileQuery = window.matchMedia('(max-width: 767.98px)');
    const topOffset = 80;
    const scrollDelta = 6;

    const setVisible = (bar, visible) => {
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');

      const link = bar.querySelector('.lp-sticky-cta__button');
      if (link) {
        link.tabIndex = visible ? 0 : -1;
      }
    };

    const initStickyCta = (bar) => {
      if (!bar || bar.dataset.ready === 'true') return;

      let lastY = window.scrollY || 0;
      let ticking = false;
      const targetId = bar.getAttribute('data-target');
      const target = targetId ? document.getElementById(targetId) : null;

      const update = () => {
        ticking = false;

        if (!mobileQuery.matches) {
          setVisible(bar, false);
          return;
        }

        const y = window.scrollY || 0;

        if (target) {
          const rect = target.getBoundingClientRect();
          if (rect.top < window.innerHeight * 0.7) {
            setVisible(bar, false);
            lastY = y;
            return;
          }
        }

        if (Math.abs(y - lastY) < scrollDelta) return;

        if (y <= topOffset) {
          setVisible(bar, false);
        } else if (y < lastY) {
          setVisible(bar, true);
        } else {
          setVisible(bar, false);
        }

        lastY = y;
      };

      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      mobileQuery.addEventListener('change', () => setVisible(bar, false));
      setVisible(bar, false);
      bar.dataset.ready = 'true';
    };

    const initAll = (root = document) => {
      root.querySelectorAll('[data-lp-sticky-cta]').forEach(initStickyCta);
    };

    initAll();

    document.addEventListener('shopify:section:load', (event) => {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portal-clinico-biblioteca"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const getYoutubeId = (url) => {
      const match = String(url).match(
        /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/|live\/))([A-Za-z0-9_-]{11})/
      );
      return match ? match[1] : '';
    };

    const getVimeoId = (url) => {
      const match = String(url).match(/vimeo\.com\/(?:video\/)?(\d+)/);
      return match ? match[1] : '';
    };

    const createFallback = (src, title) => {
      const fallback = document.createElement('div');
      fallback.className = 'portal-clinico-biblioteca-preview__fallback';

      const text = document.createElement('p');
      text.textContent = 'Não foi possível carregar a prévia deste material.';

      const openLink = document.createElement('a');
      openLink.href = src;
      openLink.target = '_blank';
      openLink.rel = 'noopener noreferrer';
      openLink.textContent = 'Abrir em nova aba';

      fallback.append(text, openLink);
      fallback.dataset.title = title;
      return fallback;
    };

    const loadScript = (src) => {
      const existing = document.querySelector(`script[data-pdf-preview-src="${src}"]`);
      if (existing) {
        return existing.dataset.loaded === 'true'
          ? Promise.resolve()
          : new Promise((resolve, reject) => {
              existing.addEventListener('load', () => resolve());
              existing.addEventListener('error', () => reject(new Error('pdfjs')));
            });
      }

      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.dataset.pdfPreviewSrc = src;
        script.addEventListener('load', () => {
          script.dataset.loaded = 'true';
          resolve();
        });
        script.addEventListener('error', () => reject(new Error('pdfjs')));
        document.head.append(script);
      });
    };

    const ensurePdfJs = async (root) => {
      if (window.pdfjsLib) return window.pdfjsLib;

      const scriptSrc = root.getAttribute('data-pdf-js');
      const workerSrc = root.getAttribute('data-pdf-worker');
      if (!scriptSrc) throw new Error('pdfjs');

      await loadScript(scriptSrc);
      if (!window.pdfjsLib) throw new Error('pdfjs');

      if (workerSrc) {
        window.pdfjsLib.GlobalWorkerOptions.workerSrc = workerSrc;
      }

      return window.pdfjsLib;
    };

    const fileSizeCache = new Map();

    const toAbsoluteUrl = (value) => {
      try {
        return new URL(value, window.location.href).href;
      } catch (_) {
        return '';
      }
    };

    const formatFileSize = (bytes) => {
      if (!Number.isFinite(bytes) || bytes <= 0) return '';

      const units = ['B', 'KB', 'MB', 'GB'];
      let unitIndex = 0;
      let value = bytes;

      while (value >= 1024 && unitIndex < units.length - 1) {
        value /= 1024;
        unitIndex += 1;
      }

      const rounded = unitIndex === 0 || value >= 10
        ? Math.round(value)
        : Math.round(value * 10) / 10;

      return `${String(rounded).replace('.', ',')} ${units[unitIndex]}`;
    };

    const readContentLength = async (url) => {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 5000);

      try {
        try {
          const head = await fetch(url, {
            method: 'HEAD',
            mode: 'cors',
            signal: controller.signal
          });
          const headLength = Number(head.headers.get('content-length'));

          if (head.ok && Number.isFinite(headLength) && headLength > 0) {
            return headLength;
          }
        } catch (_) {
        }

        const ranged = await fetch(url, {
          method: 'GET',
          mode: 'cors',
          headers: { Range: 'bytes=0-0' },
          signal: controller.signal
        });
        const range = ranged.headers.get('content-range');

        if (range && range.includes('/')) {
          const total = Number(range.split('/').pop());

          if (Number.isFinite(total) && total > 0) return total;
        }

        const length = Number(ranged.headers.get('content-length'));

        if (Number.isFinite(length) && length > 1) return length;

        return null;
      } catch (_) {
        return null;
      } finally {
        clearTimeout(timeoutId);
      }
    };

    const getFileSize = async (url) => {
      if (fileSizeCache.has(url)) return fileSizeCache.get(url);

      const pending = readContentLength(url);
      fileSizeCache.set(url, pending);
      const bytes = await pending;

      if (!bytes) fileSizeCache.delete(url);

      return bytes;
    };

    const fillFileSize = async (node, url) => {
      const bytes = await getFileSize(url);

      if (!bytes || !node.isConnected) return;

      node.textContent = formatFileSize(bytes);
    };

    const initFileSizes = (root) => {
      const nodes = root.querySelectorAll('[data-biblioteca-file-size]');

      for (const node of nodes) {
        const url = toAbsoluteUrl(node.getAttribute('data-file-src') || '');

        if (!url.startsWith('http')) continue;

        fillFileSize(node, url);
      }
    };

    const fetchPdfBytes = async (src) => {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 12000);

      try {
        const response = await fetch(src, {
          mode: 'cors',
          signal: controller.signal
        });
        if (!response.ok) throw new Error('pdf');
        return new Uint8Array(await response.arrayBuffer());
      } finally {
        clearTimeout(timeoutId);
      }
    };

    const clearMedia = (media) => {
      if (!media) return;

      const video = media.querySelector('video');
      if (video) {
        video.pause();
        video.removeAttribute('src');
        video.load();
      }

      media.replaceChildren();
    };

    const MIN_ZOOM = 0.5;
    const MAX_ZOOM = 3;
    const ZOOM_STEP = 0.25;

    const clampZoom = (value) => Math.min(MAX_ZOOM, Math.max(MIN_ZOOM, Math.round(value * 100) / 100));

    const formatZoom = (zoom) => `${Math.round(zoom * 100)}%`;

    const getPixelRatio = () => Math.min(window.devicePixelRatio || 1, 3);

    const renderPdfPages = async (scroller, pdf, media, zoom, renderToken) => {
      const fitWidth = Math.max(scroller.clientWidth || media.clientWidth, 280);
      const cssWidth = fitWidth * zoom;
      const pixelRatio = getPixelRatio();
      const pageCount = Math.min(pdf.numPages, 30);
      const scrollRatioX = scroller.scrollWidth
        ? scroller.scrollLeft / scroller.scrollWidth
        : 0;
      const scrollRatioY = scroller.scrollHeight
        ? scroller.scrollTop / scroller.scrollHeight
        : 0;

      scroller.replaceChildren();

      for (let pageNumber = 1; pageNumber <= pageCount; pageNumber += 1) {
        if (scroller.dataset.renderToken !== renderToken) return;

        const page = await pdf.getPage(pageNumber);
        const unscaled = page.getViewport({ scale: 1 });
        const cssScale = cssWidth / unscaled.width;
        const viewport = page.getViewport({ scale: cssScale * pixelRatio });
        const canvas = document.createElement('canvas');
        canvas.className = 'portal-clinico-biblioteca-preview__pdf-page';
        canvas.width = viewport.width;
        canvas.height = viewport.height;
        canvas.style.width = `${cssWidth}px`;
        canvas.style.height = `${unscaled.height * cssScale}px`;
        await page.render({
          canvasContext: canvas.getContext('2d'),
          viewport
        }).promise;

        if (scroller.dataset.renderToken !== renderToken) return;
        scroller.append(canvas);
      }

      scroller.scrollLeft = scrollRatioX * scroller.scrollWidth;
      scroller.scrollTop = scrollRatioY * scroller.scrollHeight;
    };

    const renderPdfPreview = async (media, src, title, root, zoom = 1) => {
      const loading = document.createElement('div');
      loading.className = 'portal-clinico-biblioteca-preview__fallback';
      loading.innerHTML = '<p>Carregando prévia...</p>';
      media.append(loading);

      try {
        const pdfjsLib = await ensurePdfJs(root);
        let source = { url: src };

        try {
          source = { data: await fetchPdfBytes(src) };
        } catch (fetchError) {
          source = { url: src };
        }

        const pdf = await pdfjsLib.getDocument(source).promise;
        const scroller = document.createElement('div');
        scroller.className = 'portal-clinico-biblioteca-preview__pdf';
        scroller.setAttribute('role', 'document');
        scroller.setAttribute('aria-label', title);
        scroller.dataset.renderToken = '1';
        loading.replaceWith(scroller);
        await renderPdfPages(scroller, pdf, media, zoom, '1');
        return pdf;
      } catch (error) {
        loading.replaceWith(createFallback(src, title));
        return null;
      }
    };

    const renderPreview = async (media, type, src, title, root, zoom = 1) => {
      clearMedia(media);

      if (!src) {
        media.append(createFallback('#', title));
        return { canDownload: false, pdf: null };
      }

      const youtubeId = getYoutubeId(src);
      const vimeoId = getVimeoId(src);
      const isPdf = type === 'pdf' || /\.pdf(?:$|[?#])/i.test(src);

      if (youtubeId) {
        const iframe = document.createElement('iframe');
        iframe.className = 'portal-clinico-biblioteca-preview__iframe';
        iframe.src = `https://www.youtube-nocookie.com/embed/${youtubeId}?autoplay=1&rel=0`;
        iframe.title = title;
        iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
        iframe.setAttribute('allowfullscreen', '');
        media.append(iframe);
        return { canDownload: false, pdf: null };
      }

      if (vimeoId) {
        const iframe = document.createElement('iframe');
        iframe.className = 'portal-clinico-biblioteca-preview__iframe';
        iframe.src = `https://player.vimeo.com/video/${vimeoId}?autoplay=1`;
        iframe.title = title;
        iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
        iframe.setAttribute('allowfullscreen', '');
        media.append(iframe);
        return { canDownload: false, pdf: null };
      }

      if (type === 'imagem') {
        const scroller = document.createElement('div');
        scroller.className = 'portal-clinico-biblioteca-preview__image-scroller';
        const image = document.createElement('img');
        image.className = 'portal-clinico-biblioteca-preview__image';
        image.src = src;
        image.alt = title;
        image.style.width = `${zoom * 100}%`;
        image.addEventListener('error', () => {
          scroller.replaceWith(createFallback(src, title));
        });
        scroller.append(image);
        media.append(scroller);
        return { canDownload: true, pdf: null };
      }

      if (type === 'video') {
        const video = document.createElement('video');
        video.className = 'portal-clinico-biblioteca-preview__video';
        video.src = src;
        video.controls = true;
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        video.addEventListener('error', () => {
          video.replaceWith(createFallback(src, title));
        });
        media.append(video);
        video.play().catch(() => {});
        return { canDownload: true, pdf: null };
      }

      if (isPdf) {
        const pdf = await renderPdfPreview(media, src, title, root, zoom);
        return { canDownload: true, pdf };
      }

      media.append(createFallback(src, title));
      return { canDownload: true, pdf: null };
    };

    const downloadFile = async (url, filename) => {
      try {
        const response = await fetch(url, { mode: 'cors' });
        if (!response.ok) throw new Error('download');

        const blob = await response.blob();
        const objectUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = objectUrl;
        link.download = filename || 'material';
        document.body.append(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(objectUrl);
      } catch (error) {
        window.open(url, '_blank', 'noopener,noreferrer');
      }
    };

    const initFilters = (root) => {
      const filters = root.querySelectorAll('[data-biblioteca-filter]');
      const cards = root.querySelectorAll('[data-biblioteca-material]');

      if (!filters.length || !cards.length) return;

      const applyFilter = (filter) => {
        filters.forEach((button) => {
          const isActive = button.dataset.bibliotecaFilter === filter;
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        cards.forEach((card) => {
          const matches = filter === 'all' || card.dataset.bibliotecaMaterial === filter;
          card.hidden = !matches;
        });
      };

      filters.forEach((button) => {
        button.addEventListener('click', () => {
          applyFilter(button.dataset.bibliotecaFilter || 'all');
        });
      });
    };

    const initPreview = (root) => {
      const modal = root.querySelector('[data-biblioteca-preview-modal]');
      if (!modal) return;

      const media = modal.querySelector('[data-biblioteca-preview-media]');
      const download = modal.querySelector('[data-biblioteca-preview-download]');
      const zoomControls = modal.querySelector('[data-biblioteca-preview-zoom]');
      const zoomLabel = modal.querySelector('[data-zoom-label]');
      const zoomIn = modal.querySelector('[data-zoom-in]');
      const zoomOut = modal.querySelector('[data-zoom-out]');
      const triggers = root.querySelectorAll('[data-biblioteca-preview-open]');

      if (!media || !download || !triggers.length) return;

      const previewState = {
        type: '',
        zoom: 1,
        pdf: null,
        renderToken: 0
      };

      const setZoomUi = () => {
        if (zoomLabel) zoomLabel.textContent = formatZoom(previewState.zoom);
        if (zoomOut) zoomOut.disabled = previewState.zoom <= MIN_ZOOM;
        if (zoomIn) zoomIn.disabled = previewState.zoom >= MAX_ZOOM;
      };

      const setZoomVisible = (visible) => {
        if (!zoomControls) return;
        zoomControls.hidden = !visible;
      };

      const resetPreviewState = () => {
        previewState.type = '';
        previewState.zoom = 1;
        previewState.pdf = null;
        previewState.renderToken += 1;
        setZoomVisible(false);
        setZoomUi();
        clearMedia(media);
      };

      const applyImageZoom = () => {
        const image = media.querySelector('.portal-clinico-biblioteca-preview__image');
        if (!image) return;
        image.style.width = `${previewState.zoom * 100}%`;
      };

      const applyPdfZoom = async () => {
        const scroller = media.querySelector('.portal-clinico-biblioteca-preview__pdf');
        if (!scroller || !previewState.pdf) return;

        previewState.renderToken += 1;
        const token = String(previewState.renderToken);
        scroller.dataset.renderToken = token;
        await renderPdfPages(scroller, previewState.pdf, media, previewState.zoom, token);
      };

      const changeZoom = async (nextZoom) => {
        previewState.zoom = clampZoom(nextZoom);
        setZoomUi();

        if (previewState.type === 'imagem') {
          applyImageZoom();
          return;
        }

        if (previewState.type === 'pdf') {
          await applyPdfZoom();
        }
      };

      modal.querySelectorAll('[data-js-close]').forEach((closeTrigger) => {
        closeTrigger.addEventListener('click', resetPreviewState);
      });

      const modalStateObserver = new MutationObserver(() => {
        if (!modal.classList.contains('active')) {
          resetPreviewState();
        }
      });
      modalStateObserver.observe(modal, { attributes: true, attributeFilter: ['class'] });

      if (zoomIn) {
        zoomIn.addEventListener('click', () => {
          changeZoom(previewState.zoom + ZOOM_STEP);
        });
      }

      if (zoomOut) {
        zoomOut.addEventListener('click', () => {
          changeZoom(previewState.zoom - ZOOM_STEP);
        });
      }

      download.addEventListener('click', (event) => {
        event.preventDefault();
        const href = download.getAttribute('href');
        if (!href || href === '#') return;
        downloadFile(href, download.dataset.filename || 'material');
      });

      triggers.forEach((trigger) => {
        trigger.addEventListener('click', async () => {
          const type = trigger.dataset.previewType || 'pdf';
          const src = trigger.dataset.previewSrc || '';
          const title = trigger.dataset.previewTitle || 'Pré-visualização do material';
          const filename = trigger.dataset.previewFilename || 'material';
          const canZoom = type === 'pdf' || type === 'imagem';

          previewState.type = type;
          previewState.zoom = 1;
          previewState.pdf = null;
          previewState.renderToken += 1;
          setZoomVisible(canZoom);
          setZoomUi();

          modal.setAttribute('aria-label', title);
          download.hidden = false;
          download.href = src || '#';
          download.dataset.filename = filename;

          if (typeof modal.show === 'function') {
            modal.show();
          }

          const result = await renderPreview(media, type, src, title, root, previewState.zoom);
          previewState.pdf = result.pdf;
          download.hidden = !result.canDownload;
          download.href = result.canDownload ? src : '#';
          setZoomVisible(canZoom && (type !== 'pdf' || Boolean(result.pdf)));
        });
      });
    };

    const initBiblioteca = (root) => {
      if (!root || root.dataset.bibliotecaReady === 'true') return;

      initFilters(root);
      initPreview(root);
      initFileSizes(root);
      root.dataset.bibliotecaReady = 'true';
    };

    document.querySelectorAll('[data-portal-clinico-biblioteca]').forEach(initBiblioteca);

    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.querySelector('[data-portal-clinico-biblioteca]');
      if (root) initBiblioteca(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portal-clinico-recursos"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initMediaCard = (card) => {
      if (!card || card.dataset.initialized === 'true') return;

      const video = card.querySelector('.portal-clinico-recursos__media-video');
      if (!video) return;

      const triggers = card.querySelectorAll('[data-portal-recursos-media-trigger]');
      const toggles = card.querySelectorAll('[data-portal-recursos-media-toggle]');
      const resumeButton = card.querySelector('[data-portal-recursos-media-resume]');

      video.controls = false;

      const startPlayback = (restart = true) => {
        try {
          if (restart) {
            video.currentTime = 0;
          }
        } catch (_) {
          // Ignore seek issues for unsupported states.
        }

        video.muted = false;
        video.controls = false;
        video.volume = 1;
        card.classList.add('is-playing');
        card.classList.remove('is-paused');
        video.play().catch(() => {
          card.classList.remove('is-playing');
          card.classList.add('is-paused');
        });
      };

      const togglePlayback = () => {
        if (video.paused) {
          startPlayback(false);
          return;
        }

        video.pause();
      };

      triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => startPlayback(true));
      });

      toggles.forEach((toggle) => {
        toggle.addEventListener('click', () => {
          if (card.classList.contains('is-playing') || card.classList.contains('is-paused')) {
            togglePlayback();
            return;
          }

          startPlayback(true);
        });
      });

      if (resumeButton) {
        resumeButton.addEventListener('click', () => startPlayback(false));
      }

      video.addEventListener('click', togglePlayback);
      video.addEventListener('pause', () => {
        if (video.ended) return;

        card.classList.remove('is-playing');
        card.classList.add('is-paused');
      });
      video.addEventListener('play', () => {
        card.classList.add('is-playing');
        card.classList.remove('is-paused');
      });
      video.addEventListener('ended', () => {
        card.classList.remove('is-playing');
        card.classList.remove('is-paused');
      });

      card.dataset.initialized = 'true';
    };

    const initAll = () => {
      document.querySelectorAll('[data-portal-recursos-media-card]').forEach(initMediaCard);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
